// src/pages/AuthPage/AuthPage.jsx
import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { BASE_URL } from "../../config/constants";
import SignUpLogin from "../SignupLogin/SignupLogin";
import { clearExplicitLogout } from "../../utils/authSession";
import {
  DEFAULT_AUTH_REDIRECT,
  normalizeInternalRedirect,
  readPostAuthRedirect,
  storePostAuthRedirect,
} from "../../utils/authRedirect";
import {
  clearBillingIntent,
  readBillingIntent,
} from "../../utils/billingIntent";

export default function AuthPage({ onAuthenticated }) {
  const location = useLocation();

  const billingIntent = useMemo(
    () => readBillingIntent(location.state),
    [location.state]
  );

  useEffect(() => {
    if (location.state?.from) storePostAuthRedirect(location.state.from);
  }, [location.state]);

  useEffect(() => {
    if (!billingIntent) clearBillingIntent();
  }, [billingIntent]);

  const handleFormSuccess = async (user) => {
    clearExplicitLogout();
    await onAuthenticated(user, billingIntent);
  };

  const requestedRedirect =
    normalizeInternalRedirect(location.state?.from) ||
    readPostAuthRedirect() ||
    DEFAULT_AUTH_REDIRECT;

  const oauthNext = encodeURIComponent(
    billingIntent
      ? billingIntent.from
      : requestedRedirect
  );

  const startOAuth = (provider) => {
    clearExplicitLogout();
    window.location.assign(`${BASE_URL}/api/auth/${provider}?next=${oauthNext}`);
  };

  return (
    <SignUpLogin
      onGoogleSignIn={() => startOAuth("google")}
      onMicrosoftSignIn={() => startOAuth("microsoft")}
      onSuccess={handleFormSuccess}
    />
  );
}
